export default {
  isLoggedIn: false,
  accessToken: null,
  signInProgress: false,
  expiresOn: null,
};
